<template>
  <div class="user">
      <div class="mt-2">
        <div
        v-if="btn_session== 'btn btn-warning btn-sm'" 
        class="ml-3 mr-2 text-center"> 
            <button 
            @click="refresh_token()"  
            :class="btn_session"
            type="button"> 
                {{ tiempo_restante  }} 
                <div>presiona para obtener más tiempo </div>
            </button>
        </div> 
    </div> 
    <div class=""> 
        <div v-if="!$sidebar.isMinimized" class="photo bg-success text-center">
          <v-icon>mdi-account-check</v-icon>
        </div> 
        <div class="font-weight-light text-center">
            <span data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="#"> 
                <span class="text-center justify-center" v-if="!$sidebar.isMinimized">
                   
                    <small class="mt-0 justify-center text-center">
                      {{ cognitoInfo.username }}
                      <br>
                      {{  getPerfil.nombres }} {{  getPerfil.apellidos }}
                       
              </small>
                </span>
                <span v-if="$sidebar.isMinimized">
                    <p>
                    <small>{{ cognitoInfo.username }} </small>  
                    </p>
                </span>
            </span> 
        </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    props: {
      title: {
        type: String,
        default: ''
      }
    }, 
    data () {
      return {
        logo: '/img/logo.jpg',
        isClosed: true
      }
    },
    computed:{
      ...mapState(['cognitoInfo', 'btn_session']),
      ...mapGetters(["getPerfil"]),
      ...mapGetters(['tiempo_restante']),
      ...mapGetters("global", [ "getRegion" ])
      

    },
    methods: {
        ...mapActions(['refresh_token']), 

      toggleMenu () {
        this.isClosed = !this.isClosed
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>
